module.exports = __webpack_public_path__ + "img/pending-sales-min.6ec91bf5.jpg";